export default {
      id: "video-event_traffic-light-violation-usage",
      viewBox: "0 0 21 21",
      url: __webpack_public_path__ + "img/icons.svg#video-event_traffic-light-violation",
      toString: function () {
        return this.url;
      }
    }